export default function() {
  let that = this

  this.gsm7bitChars =
    '@£$¥èéùìòÇ\\nØø\\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\\"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà'

  this.gsm7bitExChar = '\\^{}\\\\\\[~\\]|€'

  this.gsm7bitRegExp = RegExp('^[' + this.gsm7bitChars + ']*$')

  this.gsm7bitExRegExp = RegExp(
    '^[' + this.gsm7bitChars + this.gsm7bitExChar + ']*$'
  )

  this.gsm7bitExOnlyRegExp = RegExp('^[\\' + this.gsm7bitExChar + ']*$')

  this.GSM_7BIT = 'GSM_7BIT'

  this.GSM_7BIT_EX = 'GSM_7BIT_EX'

  this.UTF16 = 'UTF16'

  this.maxMessages = 9

  this.messageLength = {
    GSM_7BIT: 160,
    GSM_7BIT_EX: 160,
    UTF16: 70
  }

  this.multiMessageLength = {
    GSM_7BIT: 153,
    GSM_7BIT_EX: 153,
    UTF16: 67
  }

  this.count = function(message) {
    let encoding, length, messages, perMessage
    encoding = this.detectEncoding(message)
    length = message.length
    if (encoding === this.GSM_7BIT_EX) {
      length += this.countGsm7bitEx(message)
    }

    perMessage = this.messageLength[encoding]
    if (length > perMessage) {
      perMessage = this.multiMessageLength[encoding]
    }
    messages = Math.ceil(length / perMessage)

    if (messages > 1) {
      return {
        length: length,
        perMessage: perMessage,
        perMessages: perMessage * messages,
        messages: messages,
        encoding: encoding
      }
    } else {
      return {
        length: length,
        perMessage: perMessage,
        perMessages: perMessage,
        messages: messages,
        encoding: encoding
      }
    }
  }

  this.detectEncoding = function(text) {
    switch (false) {
      case text.match(this.gsm7bitRegExp) == null:
        return this.GSM_7BIT
      case text.match(this.gsm7bitExRegExp) == null:
        return this.GSM_7BIT_EX
      default:
        return this.UTF16
    }
  }

  this.countGsm7bitEx = function(text) {
    let char2, chars
    chars = function() {
      let _i, _len, _results
      _results = []
      for (_i = 0, _len = text.length; _i < _len; _i++) {
        char2 = text[_i]
        if (char2.match(that.gsm7bitExOnlyRegExp) != null) {
          _results.push(char2)
        }
      }
      return _results
    }

    return chars.call(this).length
  }

  return this
}



// WEBPACK FOOTER //
// ./src/common/helpers/SmsCounterHelper.js